export const createHeartbeatWorker = (heartbeatThreshold : number) => {
  const workerCode = `
    const HEARTBEAT_INTERVAL = 2000;
    const HEARTBEAT_THRESHOLD = ${heartbeatThreshold};

    let heartbeatInterval = null;
    let tabId = '';
    let activeTabs = {};

    const requestStorageOperation = (operation, key, value) => {
      self.postMessage({ 
        type: 'STORAGE_OPERATION', 
        payload: { operation, key, value } 
      });
    };

    const updateHeartbeat = () => {
      cleanUpStaleTabs();
      if (!tabId) return;
      
      activeTabs[tabId] = Date.now();
      requestStorageOperation('set', 'active_tabs', JSON.stringify(activeTabs));
    };

    const cleanUpStaleTabs = () => {
      const now = Date.now();
      for (const [id, lastHeartbeat] of Object.entries(activeTabs)) {
        const delta = Math.round((now - lastHeartbeat) / 1000);
        if (delta >= HEARTBEAT_THRESHOLD / 1000) {
          delete activeTabs[id];
        }
      }
    };

    self.onmessage = function(e) {
      const { type, payload } = e.data;

      switch (type) {
        case 'INIT':
          tabId = payload.tabId;
          activeTabs = payload.initialTabs || {};
          if (!heartbeatInterval) {
            heartbeatInterval = setInterval(updateHeartbeat, HEARTBEAT_INTERVAL);
          }
          break;
        
        case 'SYNC_STORAGE':
          if (payload.key === 'active_tabs') {
            try {
              activeTabs = JSON.parse(payload.value || '{}');
            } catch (e) {
              activeTabs = {};
            }
          }
          break;
        
        case 'CHECK_ACTIVE_TABS':
        case 'CHECK_CONSENT_ACTIVE_TABS':
          cleanUpStaleTabs();
          const noActiveTabs = Object.keys(activeTabs).length === 0;
          self.postMessage({ 
            type: type === 'CHECK_ACTIVE_TABS' ? 'ACTIVE_TABS_RESULT' : 'CONSENT_ACTIVE_TABS_RESULT', 
            payload: { noActiveTabs } 
          });
          break;
        
        case 'CLEANUP':
          if (heartbeatInterval) {
            clearInterval(heartbeatInterval);
            heartbeatInterval = null;
          }
          if (tabId && activeTabs[tabId]) {
            delete activeTabs[tabId];
            requestStorageOperation('set', 'active_tabs', JSON.stringify(activeTabs));
          }
          break;
      }
    };
  `;

  // Create the Blob worker
  const blob = new Blob([workerCode], { type: 'application/javascript' });
  return new Worker(URL.createObjectURL(blob));
};
